import { AppState } from "@Safemate/Store/types";
import { RootState } from "./types";

export const getLanguageCode = ({ appData: { user: { languageCode } } }: AppState) => languageCode;